import PropTypes from "prop-types";

import { StatusChip } from "components";
import { STATUS_CHIP, ORDER_PRIORITY } from "constants";
import { sentenceCase } from "utils";

const PriorityStatusChip = ({ priority }) => {
  const priorityMap = {
    [ORDER_PRIORITY.normal]: STATUS_CHIP.success,
    [ORDER_PRIORITY.high]: STATUS_CHIP.error,
  };

  const statusType = priorityMap[priority] || "";

  return priority ? (
    <StatusChip type={statusType} label={sentenceCase(priority)} />
  ) : (
    <span>-</span>
  );
};

PriorityStatusChip.propTypes = {
  priority: PropTypes.string,
};

export default PriorityStatusChip;
